import "./App.css";
import React, { Suspense } from "react";
import Spinner from "./components/Loader/Spinner";
export default function AppWrapper({ children }) {
  return (
    <div className="App">
      <Suspense fallback={<Spinner />}>
        <div className="app-content">{children}</div>
      </Suspense>
    </div>
  );
}
